<template>
    <div v-bind:class="[componentClass, sizeClass, colorClass, { animated: animated && !blockAnimation, 'animate-out': animateOut }]">
        <!--<?xml version="1.0" encoding="utf-8"?>-->
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 120 26" style="enable-background:new 0 0 120 26;" xml:space="preserve" aria-hidden="true">
            <g class="rds-ral-letter rds-ral-l5">
                <path class="st0" d="M79.3,8.6V6.8h-4.5v18.6h4.6V14.2c0-2.4,1.6-3.3,3-3.4c1.7-0.2,2.6,0.7,2.6,0.7l1.9-4.2
                    c-0.9-0.5-1.8-0.6-2.9-0.6C81.9,6.6,80.1,7.5,79.3,8.6z"/>
            </g>
            <g class="rds-ral-letter rds-ral-l4">
                <path class="st0" d="M62.5,6.6c-4.8,0-8.1,3.4-8.1,9.5c0,7.5,4.2,9.5,8.6,9.5c3.3,0,5.2-1,7.1-2.9l-2.8-2.7
                    c-1.2,1.2-2.2,1.7-4.2,1.7c-2.6,0-4.1-1.7-4.1-4.1h0h11.6v-2.1C70.6,10.4,67.7,6.6,62.5,6.6z M59,14.4c0-0.8,0.1-1.3,0.4-2
                    c0.5-1.1,1.5-1.9,3.1-1.9c1.6,0,2.6,0.8,3.1,1.9l0,0c0.3,0.7,0.4,1.2,0.4,2H59z"/>
            </g>
            <g class="rds-ral-letter rds-ral-l3">
                <path class="st0" d="M48,1.9h-4.6v4.9h-2v3.5h2v9.8c0,2.6,1.6,5.3,5.4,5.3v0h2.5v-3.9h-1.7c-1.1,0-1.6-0.6-1.6-1.7v-9.5h3.3V6.8H48
                    V1.9z"/>
            </g>
            <g class="rds-ral-letter rds-ral-l2">
                <path class="st0" d="M33.1,18c0,2.5-1.6,3.4-3.1,3.4c-1.5,0-3.1-0.9-3.1-3.4V6.8h-4.6v11.9c0,2,0.4,3.8,1.9,5.3
                    c1,1,2.5,1.6,4.4,1.6c1.7,0,3.4-0.6,4.6-1.9v1.7h4.5V6.8h-4.6V18z"/>
            </g>
            <g class="rds-ral-letter rds-ral-l1">
                <path class="st0" d="M18.2,7.8c0-4.2-3.1-7.8-8.2-7.8H0v25.4H5V15.2h3.6l5,10.1v0h5.7l-5.7-10.9C16,13.5,18.2,11.3,18.2,7.8z
                     M9.6,11.1H5V4.4h4.7v0c2.2,0,3.6,1.4,3.6,3.3C13.2,9.7,11.8,11.1,9.6,11.1z"/>
            </g>
            <g class="rds-ral-icon">
                <path class="st0" d="M118.3,9.8l0.8-3.9h-6.1L114,0h-4.1v0l-1.1,5.9h-6.1l1.1-5.9h-4.1l-1.1,5.9h-6.1l-0.8,3.9h6.1l-1.1,5.9h-6.1
                    l-0.8,3.9h6.1l-1.1,5.9h4.1l1.1-5.9h6.1l-1.1,5.9h4.1l1.1-5.9h6.1l0.8-3.9H111l1.1-5.9H118.3z M106.9,15.6h-6.1
                    c0,0,1.1-5.9,1.1-5.9h6.1L106.9,15.6z"/>
            </g>
        </svg>
    </div>
</template>

<style lang="scss">
  @import "../../styles/scss/global/animated-logo";
</style>

<script>
export default {
    props: ['animated', 'color', 'size'],
    data() {
        return {
            componentClass: 'rds-animated-logo',
            animateOut: false,
            blockAnimation: false
        }
    },
    computed: {
        colorClass() {
            return (this.color) ? this.componentClass + '--' + this.color : ''
        },
        sizeClass() {
            return (this.size) ? this.componentClass + '--' + this.size : ''
        }
    },
    watch: {
        'animated': function(newVal, oldVal) {
            if (!newVal && oldVal) {
                this.animateOut = true;
                this.blockAnimation = true;
                setTimeout(() => { this.animateOut = false; }, 500);
                setTimeout(() => { this.blockAnimation = false; }, 500);
            }
        }
    }
}
</script>
